var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"box-card"},[_c('el-page-header',{staticClass:"product-header",attrs:{"content":"商品出库"},on:{"back":_vm.goBack}}),_c('div',{staticClass:"select-container"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }